import ShimmerScreen from "../../../Layouts/ShimmerScreen"
import "./DetailPageTitleComponent.scss"

const DetailPageTitleComponent = ({ title, isLoading }) => {
    return (
        <>
        {
            isLoading ?
            <ShimmerScreen 
                case="rect"
                width="60%"
                height="3rem"
            />
            :
            <h2 
                dangerouslySetInnerHTML={{
                    __html: title
                }}
            >
            </h2>
        }
        </>
    )
}

export default DetailPageTitleComponent